<template>
  <div class="new-slide horizontal layout center center-justified">
    <div v-if="newPresentationGuideTextVisible" class="w-full h-full bg-base-0">
      <aha-lottie-player
        v-if="getPresenterLocale === 'fr'"
        :animationData="require('@/assets/animations/fr/new-slide-begin.json')"
        :autoPlay="true"
        :loop="true"
      />
      <aha-lottie-player
        v-else
        :animationData="require('@/assets/animations/new-slide-begin.json')"
        :autoPlay="true"
        :loop="true"
      />
    </div>
    <div v-if="newSlideGuideTextVisible" class="w-full h-full bg-base-0">
      <aha-lottie-player
        v-if="getPresenterLocale === 'fr'"
        :animationData="require('@/assets/animations/fr/new-slide-begin.json')"
        :autoPlay="true"
        :loop="true"
      />
      <aha-lottie-player
        v-else
        :animationData="require('@/assets/animations/new-slide.json')"
        :autoPlay="true"
        :loop="true"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  ...mapState({
    presentation: (state) => state.presentation,
    isNewPresentation: (state) => state.isNewPresentation,
  }),
  computed: {
    ...mapGetters(['getPresenterLocale']),
    newPresentationGuideTextVisible() {
      return this.isNewPresentation && this.presentation.slides.every((s) => !s.type)
    },
    newSlideGuideTextVisible() {
      return !this.isNewPresentation && !this.$store.state.slideActive.type
    },
  },
}
</script>
